import script from "./MetricasSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricasSection.vue?vue&type=script&setup=true&lang=js"

import "./MetricasSection.vue?vue&type=style&index=0&id=40b2cc38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b2cc38"]])

export default __exports__